import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="206.796524" cy="187.6204834" r="0" />
				<g className="fill--eyes eyes">
					<ellipse cx="180.0855865" cy="187.6206055" rx="7.8169193" ry="8.6854658" />
					<ellipse cx="233.1963654" cy="187.6206055" rx="7.8169193" ry="8.6854658" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M225.9395905,193.4739685c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484
						c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992
						l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867
						C223.713028,192.638031,224.7618561,193.4739685,225.9395905,193.4739685z" />
					<path d="M187.3423615,193.4739685c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484
						c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992
						l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867
						C189.568924,192.638031,188.5200958,193.4739685,187.3423615,193.4739685z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M225.9411011,193.3410492c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797
						c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906
						c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586
						c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125
						c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266
						C224.5924683,193.0690765,225.2653198,193.3410492,225.9411011,193.3410492z" />
					<path d="M187.3408508,193.3410492c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797
						c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906
						c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586
						c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125
						c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266
						C188.6894836,193.0690765,188.0166321,193.3410492,187.3408508,193.3410492z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M187.9025116,187.6206055c0,4.7968445-3.4997559,8.6854706-7.816925,8.6854706
						c-4.3171539,0-7.8169098-3.8886261-7.8169098-8.6854706c0-3.6821594,3.728363-3.6814728,7.8169098-3.6814728
						S187.9025116,183.9147949,187.9025116,187.6206055z" />
					<path d="M241.0075531,187.6206055c0,4.7968445-3.4997559,8.6854706-7.816925,8.6854706s-7.816925-3.8886261-7.816925-8.6854706
						c0-3.6821594,3.7283783-3.6814728,7.816925-3.6814728S241.0075531,183.9147949,241.0075531,187.6206055z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/ClassicDoggo/Eyes.js